export default __webpack_public_path__ + "static/media/bg.ac24610d.svg";